import { Trans } from "@lingui/macro";
import type { FunctionComponent } from "react";

export const CardHeaderTrackingIcon: FunctionComponent = () => {
  return (
    <div className="w-16 h-16 rounded-full inline-flex items-center justify-center bg-teal-500">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>
          <Trans>Project tracking icon</Trans>
        </title>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.777 9.468l2.635.432c.34.057.588.35.588.694v2.812a.703.703 0 01-.588.694l-2.635.432a9.077 9.077 0 01-.782 1.883l1.526 2.137c.2.28.168.663-.075.906l-1.988 1.988a.706.706 0 01-.906.075l-2.137-1.526a9.079 9.079 0 01-1.883.782l-.432 2.635a.703.703 0 01-.694.588h-2.812a.703.703 0 01-.694-.588l-.432-2.635a9.077 9.077 0 01-1.883-.782l-2.137 1.526a.705.705 0 01-.906-.075l-1.988-1.988a.703.703 0 01-.075-.906l1.526-2.137a9.08 9.08 0 01-.782-1.883L.588 14.1A.703.703 0 010 13.406v-2.812c0-.344.249-.637.588-.694l2.635-.432c.19-.654.45-1.284.782-1.883L2.48 5.448a.703.703 0 01.075-.906l1.988-1.988a.7.7 0 01.906-.075l2.137 1.526a9.078 9.078 0 011.883-.782L9.9.588A.703.703 0 0110.594 0h2.812c.344 0 .637.249.694.588l.432 2.635c.655.19 1.285.45 1.883.782l2.137-1.526a.7.7 0 01.906.075l1.988 1.988a.703.703 0 01.075.906l-1.526 2.137c.331.599.593 1.229.782 1.883zM5.672 12A6.335 6.335 0 0012 18.328 6.335 6.335 0 0018.328 12 6.335 6.335 0 0012 5.672 6.335 6.335 0 005.672 12z"
          fill="#fff"
        />
        <path
          d="M14.214 15.103c-.286.294-.908.294-1.194 0l-2.44-2.282a.772.772 0 01-.215-.533V8.076c0-.416.328-.753.733-.753.405 0 .732.337.732.753v3.9l2.226 2.063c.287.294.444.77.158 1.064z"
          fill="#fff"
        />
      </svg>
    </div>
  );
};
